import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { CancelIcon } from 'images'

import { PREVIEW_SIZE } from './previewSizes'

export default function MobileMediaPreview({ file, onClose }) {
  const videoRef = useRef(null)
  const size = PREVIEW_SIZE[file?.variant] ?? PREVIEW_SIZE.square

  useEffect(() => {
    if (!file) return undefined

    document.body.classList.add('body-no-scroll')

    return () => {
      document.body.classList.remove('body-no-scroll')
    }
  }, [file])

  useEffect(() => {
    const video = videoRef.current

    return () => {
      if (video) {
        video.pause()
        video.currentTime = 0
      }
    }
  }, [file])

  if (!file) return null

  const src = file.preview || file.url
  const isVideo = file.type?.startsWith('video')

  return createPortal(
    <div className="co-create-mobile-media-preview" onClick={onClose}>
      <div
        className="co-create-mobile-media-preview__dialog"
        style={{ width: size.width, height: size.height }}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="co-create-mobile-media-preview__close"
          onClick={onClose}
          aria-label="Close preview"
        >
          <CancelIcon width={16} />
        </button>

        {isVideo ? (
          <video
            ref={videoRef}
            className="co-create-mobile-media-preview__media"
            controls={false}
            src={src}
            muted
            autoPlay
            loop
            playsInline
            title={file.name || file.filename}
          />
        ) : (
          <img
            className="co-create-mobile-media-preview__media"
            src={src}
            alt={file.name || file.filename}
          />
        )}
      </div>
    </div>,
    document.body,
  )
}

MobileMediaPreview.propTypes = {
  file: PropTypes.object,
  onClose: PropTypes.func.isRequired,
}
